<template>
  <div>
    <div class="main-body margin_bottom" style="color: white">
      <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
      <div class="container" v-if="channelDetailsData">
        <div class="row">
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <div class="book_font_cover">
              <img :src="channelDetailsData.image_url" class="img-fluid" />
            </div>
          </div>
          <div class="col-12 col-md-9">
            <h2 class="book_title"></h2>

            <div class="d-flex flex-column flex-md-row gap-0 gap-md-4">
              <p class="book_author mb-1">
                <strong class="me-2">Name:</strong>
                {{ channelDetailsData.name }}
              </p>
            </div>
            <div>
              <p class="audio_artis mb-1">
                <strong class="me-2">Percentage :</strong>
                {{ channelDetailsData.percentage }}%
              </p>
              <!-- <p class="audio_artis mb-1">
              <strong class="me-2">Kabbik Percentage :</strong>
              {{ kabbikPercentage }}%
            </p> -->
            </div>
            <div class="mt-3">
              <button
                class="btn btn-primary btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#UpdateChannelModal"
              >
                Edit Channel
              </button>
              <button class="btn btn-danger btn-sm m-1">Block Channel</button>
            </div>
          </div>
          <UpdateChannelModal
            :channel_id="id"
            :channel_name="channelDetailsData.name"
            :channel_img="channelDetailsData.image_url"
          ></UpdateChannelModal>
          <AddAudioBookModal :channelId="id"></AddAudioBookModal>
        </div>
        <h5 class="text-white mt-5">
          <a
            href="javascript:void(0)"
            style="color: white"
            v-on:click="navigate(id, 'audiobooks')"
            >Audio Book</a
          >
          &nbsp;||
          <a
            href="javascript:void(0)"
            style="color: white"
            v-on:click="navigate(id, 'pendings')"
            >Pendings</a
          >
          &nbsp;||
          <a
            href="javascript:void(0)"
            style="color: white"
            v-on:click="navigate(id, 'rejects')"
            >Rejects</a
          >
          <button
            class="btn btn-primary btn-sm m-1"
            data-bs-toggle="modal"
            data-bs-target="#AddRssFeedModal"
            style="float: right"
          >
            Add From RSS
          </button>
          <button
            class="btn btn-primary btn-sm m-1"
            data-bs-toggle="modal"
            data-bs-target="#AddNewBookModal"
            style="float: right"
          >
            Add Audio Book
          </button>
        </h5>
      </div>
      <AddAudioBookRSSFeedModal :channelId="id"></AddAudioBookRSSFeedModal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import UpdateChannelModal from "../publisher/UpdateChannelModal";
import AddAudioBookModal from "../AudioBook/AddAudioBookModal";
import AddAudioBookRSSFeedModal from "../AudioBook/AddAudioBookRSSFeedModal";
export default {
  name: "AdminChannelViewLayout",
  components: {
    Loading,
    UpdateChannelModal,
    AddAudioBookModal,
    AddAudioBookRSSFeedModal,
  },
  data() {
    return {
      id: localStorage.getItem('tempChannelId'),
      channelDetailsData: [],
      AudiobookData: [],
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    navigate(id, status) {
      if (status == "audiobooks") {
        this.$router.push("/channel-details/" + id);
      } else if (status == "pendings") {
        this.$router.push("/admin-pendings/" + id);
      } else if (status == "rejects") {
        this.$router.push("/admin-reject/" + id);
      }
    },
    async getDetailsData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/channels/" + this.id,

          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.channelDetailsData = res.data;
          console.log(this.channelDetailsData);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  VeiwPendingPage() {
    this.$router.push("/pending/");
  },
  mounted() {
    this.getDetailsData();
  },
};
</script>
<style scoped>
@import "../../assets/css/channel.scss";
</style>
